import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import Download from './pages/Download';
import Footer from './components/Footer';
import './App.css';

/**
 * ScrollToTop Component
 * Scrolls to top of page when route changes
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

/**
 * Main App Component
 * Sets up React Router with all page routes
 * Includes Navbar and Footer on all pages
 */
function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        {/* Navbar - Fixed at top, appears on all pages */}
        <Navbar />
        
        {/* Route Configuration */}
        <Routes>
          {/* Home Page - Default route */}
          <Route path="/" element={<Home />} />
          
          {/* Download Page - /download */}
          <Route path="/download" element={<Download />} />
          
          {/* About Page - /about */}
          <Route path="/about" element={<About />} />
          
          {/* Privacy Policy Page - /privacy */}
          <Route path="/privacy" element={<Privacy />} />
          
          {/* Contact Page - /contact */}
          <Route path="/contact" element={<Contact />} />
        </Routes>
        
        {/* Footer - Appears on all pages */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
